"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectInfo = exports.setProjectInfo = void 0;
var _projectInfo;
function getProjectInfo() {
    return _projectInfo || {};
}
exports.getProjectInfo = getProjectInfo;
function setProjectInfo(projectInfo) {
    _projectInfo = projectInfo;
}
exports.setProjectInfo = setProjectInfo;
//# sourceMappingURL=projectInfo.js.map